module.exports = __webpack_public_path__ + "img/shangcheng1.3b5301b9.png";